import { FormControl, FormGroup } from '@angular/forms'
import { Component, OnInit, Input } from '@angular/core'

@Component({
  selector: 'address-field',
  templateUrl: './address-field.component.html',
  styleUrls: ['./address-field.component.css']
})
export class AddressFieldComponent implements OnInit {
  @Input() fieldInstance: FormControl | FormGroup
  @Input() label: string
  @Input('fieldIndex') index: number
  @Input() field: any
  @Input() create?: boolean = false
  @Input() isRequired: boolean = false
  @Input() inputValidations: any[] = []
  @Input() readOnly: boolean = false
  @Input() path: string
  @Input() isAdmin: boolean = false

  constructor() {}

  ngOnInit() {}
}
